import { UseMutationResult, UseQueryResult, useMutation, useQuery } from '@tanstack/react-query'
import {
  GetMerchantListResponse,
  GetTpMerchantListResponse,
  ReplaceDefaultMerchantInput,
  ReplaceDefaultMerchantResponse,
  CreateMerchantPairInput,
  CreateMerchantPairResponse,
  getMerchantList,
  replaceDefaultMerchant,
  getTpMerchantList,
  createMerchantPair,
} from 'services/merchantApi'

/** ดึงรายการ Speed Merchant ของโรงงาน */
export const useGetMerchantList = (factory_id: string): UseQueryResult<GetMerchantListResponse, Error> => {
  return useQuery<GetMerchantListResponse, Error>({
    queryKey: ['merchantList', factory_id],
    queryFn: () => getMerchantList(factory_id),
    enabled: !!factory_id,
    staleTime: 0, // Always fresh เพราะข้อมูลอาจเปลี่ยนจากการแก้ไข
  })
}

/** แทนที่ Default Merchant ด้วยข้อมูลใหม่ */
export const useReplaceDefaultMerchant = (factory_id: string): UseMutationResult<
  ReplaceDefaultMerchantResponse,
  Error,
  ReplaceDefaultMerchantInput,
  unknown
> => {
  return useMutation<ReplaceDefaultMerchantResponse, Error, ReplaceDefaultMerchantInput, unknown>({
    mutationFn: (input: ReplaceDefaultMerchantInput) => replaceDefaultMerchant(factory_id, input),
  })
}

/** ดึงรายการ Thailand Post Merchant ของโรงงาน — ใช้เช็คว่ามี merchant อยู่แล้วหรือยัง */
export const useGetTpMerchantList = (factory_id: string): UseQueryResult<GetTpMerchantListResponse, Error> => {
  return useQuery<GetTpMerchantListResponse, Error>({
    queryKey: ['tpMerchantList', factory_id],
    queryFn: () => getTpMerchantList(factory_id),
    enabled: !!factory_id,
    staleTime: 0,
  })
}

/** สร้าง Speed + Thailand Post merchant พร้อมกัน (ใช้ตอนยังไม่มี merchant เลยทั้งคู่) */
export const useCreateMerchantPair = (factory_id: string): UseMutationResult<
  CreateMerchantPairResponse,
  Error,
  CreateMerchantPairInput,
  unknown
> => {
  return useMutation<CreateMerchantPairResponse, Error, CreateMerchantPairInput, unknown>({
    mutationFn: (input: CreateMerchantPairInput) => createMerchantPair(factory_id, input),
  })
}
